import React, { Fragment } from 'react';
import './styles.css';
import { TEACHER, ECE } from '@BUP/constants';
import {
  PageLayout,
  WebinarElement,
  BupSpinner,
  ErrorMessage,
} from '@BUP/components';
import { Col, Row } from 'antd';
import { useAuth, useWebinars } from '@BUP/hooks';
import { useTranslation } from 'react-i18next';

const WebinarsPage = () => {
  const { user } = useAuth();
  const { isLoading, data, error } = useWebinars(
    user.organizations.id,
    user.roles.id
  );

  const [t] = useTranslation();

  if (error) return <ErrorMessage />;

  return (
    <PageLayout pageName={t('pages.webinars.pageName')}>
      <div className="webinars-page-container">
        {isLoading ? (
          <BupSpinner size="large" />
        ) : data && data.length ? (
          <>
            <div className="title-wrapper">
              {user?.roles?.type === TEACHER || user?.roles?.type === ECE ? (
                <p>{t('pages.webinars.introText1')}</p>
              ) : (
                <p>{t('pages.webinars.introText2')}</p>
              )}
            </div>
            <Row className="select-webinar-wrapper" gutter={[20, 30]}>
              {data.map((webinar) => (
                <Col
                  xs={24}
                  md={12}
                  xl={8}
                  className="element-wrapper"
                  key={`webinar-${webinar?.id}`}
                >
                  <WebinarElement webinar={webinar} />
                </Col>
              ))}
            </Row>
          </>
        ) : (
          <div className="empty-webinars bold-text">
            <h2>{t('pages.webinars.noWebinarsText')}</h2>
          </div>
        )}
      </div>
    </PageLayout>
  );
};

export default WebinarsPage;
